/**
 * Parse a string to an integer, with a fallback if parsing fails.
 * @param value The string value to parse.
 * @param fallback The fallback number if parsing fails.
 * @returns The parsed integer or the fallback.
 *
 * @example
 * parseInt("42", 0); // returns 42
 * parseInt("invalid", 0); // returns 0
 */
export function parseInt(
	value: string | undefined,
	fallback: number,
): number {
	const parsed = Number.parseInt(value ?? '', 10);

	return Number.isFinite(parsed) ? parsed : fallback;
}
